// Функция, закрывающая все попапы
const hideAllPopups = () => {
    const allPopups = document.querySelectorAll('.popup-window');

    if (allPopups) {
        allPopups.forEach((el) => {
            const thisPopup = el;
            thisPopup.classList.remove('--is-visible');
        });
    }
};

const popupCtrl = () => {
    // Все контролы для попапов
    const allPopupCtrls = document.querySelectorAll('.Popup-ctrl');

    // Если контролы есть, то начинаем обработку
    if (allPopupCtrls) {
        // Для каждого контрола
        allPopupCtrls.forEach((el) => {
            // Элемент — это наш текущий контрол
            const thisPopupCtrl = el;
            // В нем должна быть кнопка-обработчик
            const thisPopupCtrlBtn = thisPopupCtrl.querySelector('.Popup-ctrl__btn');
            // Если кнопка-обработчик есть
            if (thisPopupCtrlBtn) {
                // То наш попап — это элемент,
                // который идет следом за кнопкой (где должен размещаться попап)
                const thisPopup = thisPopupCtrlBtn.nextElementSibling;

                // Если попап найден и у него есть соответствующий класс
                if (thisPopup && thisPopup.classList.contains('popup-window')) {
                    thisPopupCtrlBtn.addEventListener('click', () => {
                        if (thisPopup.classList.contains('--is-visible') === false) {
                            hideAllPopups();
                            thisPopup.classList.add('--is-visible');
                        } else {
                            hideAllPopups();
                        }
                    });

                    const thisPopupCloseBtn = thisPopup.querySelector('.popup-window__close-this-popup');

                    if (thisPopupCloseBtn) {
                        thisPopupCloseBtn.addEventListener('click', (e) => {
                            e.preventDefault();
                            hideAllPopups();
                        });
                    }
                }
            }
        });
    }

    // Закрыть окна по нажатию на Escape
    document.addEventListener('keydown', (e) => {
        if (e.code === 'Escape') {
            hideAllPopups();
        }
    });
};

export default popupCtrl;
